import { Row, Col, Dropdown, Button } from "react-bootstrap";
import {
  FiHome,
  FiChevronRight,
  FiDownload,
  FiChevronDown,
  FiFileText,
} from "react-icons/fi";
import { FaFileExcel } from "react-icons/fa";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb, } from 'react-bootstrap';
import PurchaseTransactionList from "../../components/super-admin/dashbaord/PurchaseTransactionList";
const RecentTransactionsPage = () => {
  return (
    <div  style={{ padding: "15px", background: "#f8f9fa",  }} className="purchase-header card p-3">

<Row className="align-items-center justify-content-between">

        {/* LEFT */}

   <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Purchase Transaction</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                  Super Admin
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Purchase Transaction List</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT */}
        <Col
          md={6}
          xs={12}
          className="text-md-end mt-2 mt-md-0"
        >
          <div className="d-flex justify-content-md-end gap-2">

            {/* EXPORT */}
            <Dropdown>
              <Dropdown.Toggle className="export-btn">
                <FiDownload className="me-2" />
                Export <FiChevronDown className="ms-1" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="export-menu">
                <Dropdown.Item className="d-flex align-items-center">
                  <FiFileText className="me-2" />
                  Export as PDF
                </Dropdown.Item>

                <Dropdown.Item className="d-flex align-items-center">
                  <FaFileExcel className="me-2" />
                  Export as Excel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* OPTIONAL COLLAPSE BUTTON */}
            {/* <Button className="collapse-btn">
              <FiChevronup />
            </Button> */}

          </div>
        </Col>

      </Row>
  
      <PurchaseTransactionList/>
          <style>
          {
               `
               /* CARD STYLE */
.purchase-header {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
}

/* TITLE */
.purchase-header h4 {
  font-size: 20px;
}

/* BREADCRUMB */
.breadcrumb-custom {
  font-size: 14px;
  color: #6b7280;
}

/* EXPORT BUTTON */
.export-btn {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  color: #111827;
  font-size: 14px;
  display: flex;
  align-items: center;
}

/* DROPDOWN MENU */
.export-menu {
  border-radius: 10px;
  padding: 8px 0;
  border: none;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

/* ITEMS */
.export-menu .dropdown-item {
  font-size: 14px;
  padding: 10px 16px;
}

/* COLLAPSE BUTTON */
.collapse-btn {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

/* MOBILE */
@media (max-width: 768px) {
  .purchase-header {
    text-align: left;
  }

  .export-btn {
    width: 100%;
    justify-content: center;
  }
}`
          }
       </style>
    </div>
  );
};

export default RecentTransactionsPage;